import {useTranslation} from '@/translations/i18n'
import {InputSelectPatient} from '@/features/patients/components/input-select-patient/InputSelectPatient'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '../../types'
import {useGetPatient} from '@/features/patients/services/useGetPatient'
import {PatientSmall} from '@/features/patients/types'
import {useAccessesAccordion} from '../accesses-accordion-context-provider/AccessesAccordionContextProvider'

export const AccessesValidatorPatientFilter = ({disabled}: {disabled?: boolean}) => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(ValidatorSearchParams)
    const {collapseAll} = useAccessesAccordion()
    const {data: selectedPatient, isLoading: isSelectedPatientLoading} = useGetPatient({
        patientId: searchParams.patient,
        responseType: 'small',
        options: {enabled: !!searchParams.patient}
    })
    const onChange = (patient: PatientSmall | null) => {
        setSearchParams({patient: patient?.id})
        collapseAll()
    }

    const onClear = () => {
        setSearchParams({patient: undefined})
        collapseAll()
    }

    return (
        <InputSelectPatient
            isLoading={isSelectedPatientLoading}
            label={t('commons:patient')}
            value={selectedPatient ? {id: selectedPatient.id, fullName: selectedPatient.fullName} : undefined}
            onChange={onChange}
            placeholder="Seleziona paziente"
            hideBadge
            hideDate
            disabled={disabled}
            onClear={onClear}
        />
    )
}
